import {
  GetIdTokenClaimsOptions,
  IdToken,
  LogoutOptions,
  useAuth0,
  User
} from '@auth0/auth0-react'
import { createContext, FC, useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt'
import { useHistory } from 'react-router-dom'

import AuthAuthorize from '@view/Auth/Authorize'

import auth from '@service/auth'

export interface IUserAuth0Context {
  user: User | undefined
  userRole: string
  setLogout?: (state: boolean) => void
  logout: (options?: LogoutOptions | undefined) => void
  getIdTokenClaims: (
    options?: GetIdTokenClaimsOptions
  ) => Promise<IdToken | undefined>
}

export interface TokenProps {
  aud: string
  exp: number
  iat: number
  iss: string
  jti: string
  nbf: number
  canReviewStatusChange: string
  role: string
  email?: string
  sub: string
  user?: string
  // eslint-disable-next-line camelcase
  unique_name: string
  idPerfil: number | string
}
export const UserAuth0Provider: FC = ({ children }) => {
  const navigate = useHistory()
  const [firstRender, setFirstRender] = useState(true)
  const [loading, setLoading] = useState(true)
  const [, setLogout] = useState(false)
  const [count, setCount] = useState(0)

  // const { setLoading } = useAuth()

  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE

  const [userRole] = useState('')

  const { user, logout, getIdTokenClaims, isAuthenticated } = useAuth0()

  const getRoles = async () => {
    setLoading(true)
    const userInfos = JSON.parse(
      localStorage.getItem(
        `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
      )
    )
    const decodedToken = decodeToken(userInfos?.body.access_token) as TokenProps

    setCount(count + 1)
    if (decodedToken && firstRender) {
      await auth
        .getUserPopulateData()
        .then(async () => {
          // const token = await getAccessTokenSilently({
          //   ignoreCache: true
          // })
          if (decodedToken?.user === undefined) {
            window.location.reload()
          } else {
            setLoading(false)
            setFirstRender(false)
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 400) {
            setLoading(false)

            navigate.push('/not-authorized')
          } else if (error.response && error.response.status === 401) {
            window.location.reload()
            setFirstRender(true)
          } else {
            setLoading(false)
            setFirstRender(false)
            navigate.push('/not-authorized')

            // handle other errors
          }

          // navigate.push('/not-authorized')
        })
    }
    if (!decodedToken && firstRender) {
      setLoading(false)
    }
    if (decodedToken && !firstRender) {
      setLoading(false)
    }
    if (!decodedToken && !isAuthenticated && !firstRender) {
      setLoading(false)
    }
  }
  useEffect(() => {
    getRoles()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])
  return (
    <UserAuth0Context.Provider
      value={{
        user,
        userRole,
        setLogout,
        logout,
        getIdTokenClaims
      }}
    >
      {loading ? <AuthAuthorize /> : children}
    </UserAuth0Context.Provider>
  )
}
export default UserAuth0Provider
export const UserAuth0Context = createContext<IUserAuth0Context>(
  {} as IUserAuth0Context
)
